<template>
  <section class="boss-skill-sheet">
    <table class="unstriped boss-table">
      <thead>
        <tr>
          <th
            class="boss-table-head"
            colspan="2"
          >
            職務経歴書
          </th>
        </tr>
      </thead>
      <tbody>
        <template
          v-for="(careerResume, i) in member.careerResumes"
        >
          <tr :key="'tr1-'+ i">
            <td
              class="boss-table-data-head"
              rowspan="2"
              data-test="resume-from-to"
            >
              {{ careerResumeFromTo(careerResume) }}
            </td>
            <td
              class="boss-table-data pega-resume-name-word-break-all"
              data-test="resume-name"
            >
              {{ careerResume | careerResumeNameFilter }}
            </td>
          </tr>
          <tr :key="'tr2-'+ i">
            <td
              class="boss-table-data pega-break pega-pre-wrap"
              data-test="resume-description"
              v-text="careerResume.description"
            />
          </tr>
        </template>
      </tbody>
    </table>
    <table class="unstriped boss-table">
      <tr>
        <td class="boss-table-data-head">
          最終学歴
        </td>
        <td
          class="boss-table-data pega-break"
          colspan="2"
          data-test="graduated-school"
        >
          {{ member | graduatedSchoolFilter }}
        </td>
      </tr>
      <tr>
        <td class="boss-table-data-head">
          学歴補足事項
        </td>
        <td
          class="boss-table-data pega-break"
          colspan="2"
          data-test="educational-background-note"
        >
          {{ member | defaultLabelFilter('educationalBackgroundNote') | parseBlankForDefaultValue() }}
        </td>
      </tr>
      <tr>
        <td class="boss-table-data-head">
          経験職種
        </td>
        <td
          class="boss-table-data"
          colspan="2"
          data-test="experienced-occupations"
        >
          {{ member | experiencedOccupationsFilter }}
        </td>
      </tr>
      <tr>
        <td class="boss-table-data-head">
          経験業種
        </td>
        <td
          class="boss-table-data"
          colspan="2"
          data-test="experienced-sectors"
        >
          {{ member | defaultLabelFilter('experiencedBusinesses') | parseBlankForDefaultValue() }}
        </td>
      </tr>
      <tr>
        <td class="boss-table-data-head">
          資格
        </td>
        <td
          class="boss-table-data pega-break"
          colspan="2"
          data-test="license"
        >
          {{ member | licenseFilter }}
        </td>
      </tr>
      <tr
        v-for="(skill, index) in skills"
        :key="index"
      >
        <td
          v-if="index === 0"
          :rowspan="skills.length"
          class="boss-table-data-head"
        >
          スキル
        </td>
        <td
          class="boss-table-data pega-resume-sub-title"
          :data-test="`skill-name-${index}`"
        >
          {{ skill.name }}
        </td>
        <td
          class="boss-table-data"
          :data-test="`skill-note-${index}`"
        >
          {{ skill.note | parseBlankForDefaultValue() }}
        </td>
      </tr>
      <tr>
        <td class="boss-table-data-head">
          語学
        </td>
        <td
          class="boss-table-data pega-break"
          colspan="2"
          data-test="english"
        >
          {{ member | englishFilter }}
        </td>
      </tr>
      <tr>
        <td
          class="boss-table-data-head"
          rowspan="6"
        >
          希望条件
        </td>
        <td class="boss-table-data">
          転職意欲
        </td>
        <td
          class="boss-table-data pega-resume-sub-title"
          data-test="change-jobs-motivation"
        >
          {{ member | defaultLabelFilter('changeJobsMotivation.name') | parseBlankForDefaultValue() }}
        </td>
      </tr>
      <tr>
        <td class="boss-table-data pega-resume-sub-title">
          希望年収
        </td>
        <td
          class="boss-table-data"
          data-test="desired-salary"
        >
          {{ member | defaultLabelFilter('desiredSalary') | parseBlankForDefaultValue('万円以上') }}
        </td>
      </tr>
      <tr>
        <td class="boss-table-data pega-resume-sub-title">
          会社のタイプ
        </td>
        <td
          class="boss-table-data"
          data-test="company-style"
        >
          {{ member | defaultLabelFilter('companyStyle.name') | parseBlankForDefaultValue() }}
        </td>
      </tr>
      <tr>
        <td class="boss-table-data pega-resume-sub-title">
          希望勤務地
        </td>
        <td
          class="boss-table-data"
          data-test="desired-work-prefectures"
        >
          {{ member | defaultLabelFilter('desiredWorkPrefectures') | parseBlankForHopeValue() }}
        </td>
      </tr>
      <tr>
        <td class="boss-table-data pega-resume-sub-title">
          希望職種
        </td>
        <td
          class="boss-table-data"
          data-test="desired-occupations"
        >
          {{ member | defaultLabelFilter('desiredOccupations') | parseBlankForHopeValue() }}
        </td>
      </tr>
      <tr>
        <td class="boss-table-data pega-resume-sub-title">
          希望業種
        </td>
        <td
          class="boss-table-data"
          data-test="desired-sectors"
        >
          {{ member | defaultLabelFilter('desiredBusinesses') | parseBlankForHopeValue() }}
        </td>
      </tr>
      <tr>
        <td class="boss-table-data-head">
          自己PR
        </td>
        <td
          class="boss-table-data pega-break pega-pre-wrap"
          data-test="self-pr"
          colspan="2"
          v-text="$options.filters.parseBlankForDefaultValue($options.filters.defaultLabelFilter(member, 'publicRelations'))"
        />
      </tr>
    </table>
  </section>
</template>

<script>

import _ from 'lodash'
import { parseHierarchicalObjects } from '@/lib/parse'
import { mapGetters } from 'vuex'
import { createDate } from '@/lib/dateUtils.js'
import * as parse from '@/lib/parse'

export default {
  filters: {
    // 第1引数（label）が真偽判定で偽となる値（nullとか''とか0とかfalseとか...）の場合は'未登録' を返却する
    // それ以外の場合は第1引数（label）+ 第3引数（suffix）を返却する
    parseBlankForDefaultValue (label, suffix = '') {
      return label ? label + suffix : '未登録'
    },
    // 第1引数（label）が真偽判定で偽となる値（nullとか''とか0とかfalseとか...）の場合は 'こだわらない・未入力' を返却する
    // それ以外の場合は第1引数（label）+ 第3引数（suffix）を返却する
    parseBlankForHopeValue (label, suffix = '') {
      return label ? label + suffix : 'こだわらない・未入力'
    },
    experiencedOccupationsFilter (member) {
      return (_.get(member, 'experiencedOccupations') || []).map(x => {
        const yearLabel = x.years !== null ? (x.years === 0 ? '1ヶ月以上' : x.years + '年') : '経験年数未設定'
        return `${x.name} ${yearLabel}`
      }).join('、') || '未登録'
    },
    careerResumeNameFilter (careerResume) {
      const companyName = _.get(careerResume, 'companyName')
      const publicationCompanyName = _.get(careerResume, 'publicationCompanyName')
      const employeesNumber = _.get(careerResume, 'employeesNumber')
      const employmentPatternName = _.get(careerResume, 'employmentPattern.name')
      const annualSalary = _.get(careerResume, 'annualSalary')
      return `${publicationCompanyName ? companyName || '社名未登録' : '****(社名非公開)****'}（従業員数${parse.numberValue(employeesNumber, '名')}）　${employmentPatternName || '雇用形態未登録'}　年収${parse.numberValue(annualSalary, '万円')}`
    },
    graduatedSchoolFilter (member) {
      const name = _.get(member, 'graduatedSchool.name')
      const department = _.get(member, 'graduatedSchool.department')
      const yearMonth = _.get(member, 'graduatedSchool.yearMonth', '')
      if (!name && !department && !yearMonth) return '未登録'
      return `${name || '学校名未登録'}　${department || '学部学科未登録'}（${createDate(yearMonth)?.format('YYYY年MM月卒業') ?? '卒業年月未登録'}）`
    },
    englishFilter (member) {
      const toeicScore = _.get(member, 'toeicScore')
      const toeflScore = _.get(member, 'toeflScore')
      const englishSkillName = _.get(member, 'englishSkill.name')
      const languagesOtherThanEnglish = _.get(member, 'languagesOtherThanEnglish')
      return `TOEIC：　${parse.numberValue(toeicScore, '点')}　／　TOEFL：　${parse.numberValue(toeflScore, '点')}　／　英語スキル：　${englishSkillName || '未登録'}　／　英語以外の語学スキル：　${languagesOtherThanEnglish || '未登録'}`
    },
    licenseFilter (member) {
      const otherLicense = _.get(member, 'otherLicense') || ''
      const licenseNames = (_.get(member, 'licenses') || []).map(license => license.name)
      const skillsNote = _.get(member, 'skillsNote') || ''
      return _.compact([otherLicense, ...licenseNames, skillsNote]).join('、') || '未登録'
    },
    defaultLabelFilter (member, path) {
      const obj = _.get(member, path)
      if (Array.isArray(obj)) {
        return obj.map(x => x.name).join('、')
      } else {
        return obj
      }
    }
  },
  props: {
    member: {
      type: Object,
      required: true
    }
  },
  computed: {
    skills () {
      return [
        { name: '経験業務', note: this.getSkillExperiences('経験業務', 1, 0) },
        { name: '経験分野', note: this.getSkillExperiences('経験分野', 1, 0) },
        { name: '開発環境', note: this.getSkillExperiences('開発環境', 1, 2) },
        { name: '電気・電子・機械・メカトロ関連', note: this.getSkillExperiences('保有スキル', 1, 2) },
        { name: 'クリエイティブ関連職種', note: this.getSkillExperiences('使用ソフトウェア', 1, 2) }
      ]
    },
    ...mapGetters({
      skillsMaster: 'skillsMaster'
    })
  },
  methods: {
    getSkillExperiences (filterName, groupLayer, subGroupLayer = groupLayer) {
      if (!this.member.skills) return ''
      const experiences = _.at(_.groupBy(
        _.filter(parseHierarchicalObjects(this.skillsMaster), master => {
          return this.member.skills.some(skill => skill.id === master.id)
        }),
        o => {
          return o.path[groupLayer].name
        }
      ), filterName).reduce((arr, it) => (it) ? [...arr, ...it] : arr, [])

      if (experiences.length === 0) {
        return ''
      }
      // 経験年数と補足情報注入
      experiences.map(experience => {
        const experienceSkill = this.member.skills.find(skill => skill.id === experience.id)
        experience.year = experienceSkill.experiencedYears
        experience.note = experienceSkill.note
      })

      const categories = _.groupBy(experiences, experience => {
        return experience.path[subGroupLayer].name
      })
      return Object.keys(categories).map(key => {
        return `[${key}]${categories[key].map(i => {
          return `${i.name}（${i.year}）${i.note ? `:${i.note}` : ''}`
        }).join('、')}`
      }).join(' / ')
    },
    careerResumeFromTo (careerResume) {
      const firstYear = _.get(careerResume, 'firstYear')
      const lastYear = _.get(careerResume, 'lastYear')
      // 入社年および退社年が未設定＝直近の勤務期間未登録と判断する。
      if (!firstYear && !lastYear) return '未登録'
      // 退社年に9999が設定されている場合は'現在就業中'とする
      return `${this.toLocalDate(firstYear, _.get(careerResume, 'firstMonth'))}〜${lastYear === 9999 ? '現在就業中' : this.toLocalDate(lastYear, _.get(careerResume, 'lastMonth'))}`
    },
    toLocalDate (year, month) {
      return createDate(`${year}-${month}`, 'YYYY-M')?.format('YYYY年MM月') ?? '未登録'
    }
  }
}
</script>
